module.exports = __webpack_public_path__ + "img/PCLX.07adcd86.png";